<style>
  div{
    font-family: "Microsoft Yahei";
  }
  ul,li{
    list-style: none !important;
    cursor: pointer;
  }
  .menuname:hover{
    text-decoration: underline;
  }
  .menuname.active{
    background-color:#0088CC;
    color:#ffffff;
  }
</style>

<template>
  <div>
    <li>
      <div @click='toggle()'  style="font-size:16px;" >
        <i   v-if='isFolder' class="fa " :class="[open?'fa-minus-square-o':'fa-plus-square-o']"></i>
        <i v-if='isFolder' class="fa " :class="[open?'fa-folder-open':'fa-folder']"></i>
        <!--isFolder判断是否存在子级-->
        <i v-if='!isFolder' class="fa fa-file-text"></i>
        <i class="menuname">{{model.name}}</i>
      </div>
      <ul v-show="open" v-if='isFolder'>
        <items v-for="item in model.children" :model="item"></items>
      </ul>
    </li>
  </div>

</template>

<script>
  export default {
    name: 'items',
    props: ['model'],
    components: {},
    data() {
      return {
        open: false,
        isFolder: true,
      }
    },
    computed: {
      isFolder: function() {
        return this.model.childTreeNode && this.model.childTreeNode.length
      },
    },
    mounted(){
      $(".menuname").click(function() {
        $(".menuname").removeClass("active");
        $(this).addClass("active");
        $(".menuname").val($(this).find('i').attr('class'));
      })
    },
    methods: {
      toggle: function() {
        if(this.isFolder) {
          this.open = !this.open
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// treeselect.vue?d5fedd74